<template>
  <div class="fu-drai" data-test="fu-drawer-ai-form">
    <fu-icon name="bot" :size="16" />
    <span>Teamio’s AI assistant calls {{ firstName || 'the patient' }} from your practice number and logs the outcome here. This is a simulation — no real call is placed.</span>
  </div>
</template>

<script>
/**
 * DrawerAiCallForm — the Super Admin "AI call [SIM]" notice (the design's copy). The call itself is
 * today's triggerAutorecallCall, placed by the container (drawerPayload.buildAiCallPayload).
 * Presentational.
 */
import FuIcon from '../FuIcon.vue';

export default {
  name: 'DrawerAiCallForm',
  components: { FuIcon },
  props: {
    firstName: { type: String, default: '' },
  },
};
</script>

<style lang="scss" scoped>
@import './drawer';

.fu-drai {
  @include fu-dr-soft-note;
  font-size: 13px;
  line-height: 1.5;
  .fu-icon { flex: none; margin-top: 2px; color: $fu-text-muted; }
}
</style>
